<template>
  <div class="main">
    <div class="device-container">
      <div style="width: 100vw;min-height:80vh;height:90vh" id="myMap"
           ref="myMap"></div>

    </div>
  </div>
</template>

<script>
import {getSpaceInfoById} from "@/network/space-info";
import {getDeviceListBySpaceIdAndCategoryTagId} from "@/network/device-info";
import {getSpaceMap} from "@/network/space-map";
import 'ol/ol.css';
import Map from 'ol/Map';
import View from 'ol/View';
import ImageLayer from "ol/layer/Image";
import {ImageStatic} from "ol/source";
import {Projection} from "ol/proj";
import {getCenter} from "ol/extent";
import * as olInteraction from 'ol/interaction'
import DragRotateAndZoom from 'ol/interaction/DragRotateAndZoom'
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {LineString, Point} from "ol/geom";
import {FullScreen} from "ol/control";
import {defaults as defaultControls} from "ol/control";
import Zoom from "ol/control/Zoom";
import {Icon, Stroke, Style, Text} from 'ol/style';
import Fill from "ol/style/Fill";
import Feature from 'ol/Feature';

export default {
  name: "IndoorSetting",
  props: {
    spaceId: {
      type: String,
      default: () => '0'
    },
    categoryTagId: {
      type: String,
      default: () => null
    },
    indoorType: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      spaceInfo: {},
      spaceMap: [],
      deviceListWidthId: null,
      deviceListId: [],
      // 当前鼠标移动到的设备
      currentSelectDeviceId: 0,
      // 定时器遍历选择设备效果
      timerSelectDeviceId: 0,
      // 定时器当前选中的下表
      timerSelectDeviceIndex: 0,
      imgWidth: 0,
      imgHeight: 0,
      initWidth: 0,
      initHeight: 0,
      /* start
      *GIS地图参数*/
      map: null, // 地图
      // 漏水线图层集合
      slackLineLayers: [],
      imgx: 1432, // 当前地图宽
      imgy: 1002, // 当前地图高
      // 鼠标坐标管理器
      mousePositionControl: "",
      // 地图背景图层
      mapImageLayers: null,
      // 图标管理器
      iconLayer: null,
      // 鼠标悬浮图层
      hoverFeature: null,
      // 图标集合
      featureList: [],
      // 轮询显示图标设备名称定时器
      showDeviceTimer: null,
      // 定时更新设备图标
      updateDeviceIconTimer: null,
      // 循环判断内景图是否初始化
      createMapTimer: null,
      // 设备集合
      deviceList: []
      /* end
      *GIS地图参数*/
    }
  },
  methods: {
    // 重新设置底图和设备图标
    changeDeviceMapImage() {
      // 重新设置地图背景图层
      this.getMapImageLayer();
      this.map.addLayer(this.mapImageLayers)
      // 初始化图标图层
      this.initDevicePointList();
    },
    // 获取内景图图片宽高
    getBgImageInfo(fucObject) {
      // 图片地址
      let img_url = this.spaceInfo === undefined || this.spaceInfo === null || this.spaceInfo.bgImage === null || this.spaceInfo.bgImage === '' ? require('@/assets/images/no-bg.png') : this.$ftpUrl + this.spaceInfo.bgImage  // 静态地图
      // 创建对象
      let img = new Image();
      // 改变图片的src
      img.src = img_url;
      let that = this;
      // 加载完成执行
      img.onload = function () {
        that.imgy = img.height
        that.imgx = img.width
        fucObject()
      }
    },
    // 定时器选择设备事件
    timerSelectDevice() {
      if (this.deviceListId.length <= 0) {
        return
      }
      if (this.timerSelectDeviceIndex > this.deviceListId.length - 1) {
        this.timerSelectDeviceIndex = 0
      }
      this.timerSelectDeviceId = this.deviceListId[this.timerSelectDeviceIndex++]
    },
    getDeviceList(spaceId) {
      getDeviceListBySpaceIdAndCategoryTagId(spaceId, this.categoryTagId).then(res => {
        if (res.data) {
          this.deviceList = []
          this.deviceList = res.data
          this.checkDeviceValueOrPosition();
          this.deviceListWidthId = {}
          this.deviceListId = []
          this.deviceList.forEach(device => {
            this.deviceListId.push(device.id)
            this.deviceListWidthId[device.id] = device
          })
          this.getSpaceMap(this.spaceInfo.id)
        }
      })
    },
    getSpaceMap(spaceId) {
      if (spaceId === '' || spaceId === null || spaceId === undefined) {
        return
      }
      getSpaceMap(spaceId).then(res => {
        if (res.data) {
          this.spaceMap = res.data
          this.addSlacklineList()
        }
      })
    },
    // 通过空间id获取空间信息
    async getSpaceInfo(id) {
      if (id === '') {
        return
      }
      await getSpaceInfoById(id).then(res => {
        if (res.data) {
          this.spaceInfo = res.data
          this.getDeviceList(this.spaceInfo.id)
        }
      })
    },
    showDeviceDetails(deviceId) {
      this.$emit("showDeviceDetail", deviceId)
    },
    // 设置地图背景图片
    getMapImageLayer() {
      let extent = [0, 0, this.imgx, this.imgy];  // 获取图片的宽高
      // [minx, miny, maxx, maxy].
      let projection = new Projection({
        code: "xkcd-image",
        units: "pixels",
        extent: extent
      });
      this.mapImageLayers = null;
      this.mapImageLayers = new ImageLayer({
        source: new ImageStatic({
          url: this.spaceInfo === undefined || this.spaceInfo === null || this.spaceInfo.bgImage === null || this.spaceInfo.bgImage === '' ? require('@/assets/images/no-bg.png') : this.$ftpUrl + this.spaceInfo.bgImage,  // 静态地图
          projection: projection,
          imageExtent: extent
        })
      })
      // 重新设置中心点
      this.map.getView().setCenter(getCenter(extent))
      this.map.getView().setZoom(1);
    },
    // 初始化GIS地图
    async initMap() {
      let extent = [0, 0, this.imgx, this.imgy];  // 获取图片的宽高
      // [minx, miny, maxx, maxy].
      let projection = new Projection({
        code: "xkcd-image",
        units: "pixels",
        extent: extent
      });
      // 设置地图背景图层
      this.mapImageLayers = await new ImageLayer({
        source: new ImageStatic({
          url: this.spaceInfo === undefined || this.spaceInfo === null || this.spaceInfo.bgImage === null || this.spaceInfo.bgImage === '' ? require('@/assets/images/no-bg.png') : this.$ftpUrl + this.spaceInfo.bgImage,  // 静态地图
          projection: projection,
          imageExtent: extent
        })
      })
      this.map = await new Map({
        target: "myMap",
        // shift控制旋转
        interactions: olInteraction.defaults().extend([new DragRotateAndZoom()]),
        // 缩放等级zoom当前缩放程度，maxZoom最大缩放程度
        view: new View({
          projection: projection,
          center: getCenter(extent),
          // 当前缩放倍数
          zoom: this.indoorType === 'list' ? 1 : 2.5,
          // 最大缩放倍数
          maxZoom: 7
        }),
        controls: defaultControls({
          rotate: true,
        }).extend([
          new FullScreen({
            tipLabel: "全屏"
          }),
          new Zoom({
            zoomInTipLabel: "放大",
            zoomOutTipLabel: "缩小"
          })
        ])
      });
      await this.map.addLayer(this.mapImageLayers);
      /**
       * 添加图标集合
       */
      this.addDevicePointList()
      this.pollShowDeviceText();
      // 修改旋转鼠标悬浮tip
      document.getElementsByClassName('ol-rotate-reset')[0].attributes.title.nodeValue = '重置旋转'
      clearInterval(this.createMapTimer)
      this.createMapTimer = null;
    },
    // 移除鼠标位置
    removeMousePosition() {
      if (this.mousePositionControl) {
        // 移除
        this.map.removeControl(this.mousePositionControl)
        this.mousePositionControl = null
      }
    },
    // 添加图标
    addDevicePoint(item) {
      let convertX = item.xoffset * this.imgx / 100;
      let convertY = this.imgy - (item.yoffset * this.imgy / 100);
      // 设置图片位置
      const iconFeature = new Feature({
        geometry: new Point([convertX, convertY])
      })
      // 设置样式，这里使用图片
      iconFeature.setStyle([
        new Style({
          image: new Icon({
            // 指定锚 x 值的单位。的值'fraction'表示 x 值是图标的一部分。的值'pixels'表示以像素为单位的 x 值。
            anchorXUnits: 'fraction',
            // 左下角为原点
            anchorOrigin: 'bottom-left',
            anchorYUnits: 'fraction',
            anchor: [0.5, 0],
            src: this.deviceListWidthId[item.deviceId].status === 0 ? this.$ftpUrl + this.deviceListWidthId[item.deviceId].icon : this.$ftpUrl + this.deviceListWidthId[item.deviceId].iconAlarm
          }),
          zIndex: 3
        }),
        new Style({
          text: new Text({
            text: '',
            font: "14px Microsoft YaHei",
            offsetY: -15,
            offsetX: 15,
            padding: [5, 10, 5, 15],
            textAlign: 'left',
            backgroundFill: new Fill({
              // eslint-disable-next-line no-constant-condition
              color: this.deviceListWidthId[item.deviceId].status === 0 ? 'rgba(0,111,255,0.5)' : 'rgba(249, 88, 87, 0.5)'//提示背景色
            }),
            fill: new Fill({
              color: "#fff"
            }),
          }),
          zIndex: 2
        }),
      ])
      // 给图层设置设备图标name和id属性，用作独立 区分
      iconFeature.deviceName = item.deviceName
      iconFeature.deviceId = item.deviceId
      iconFeature.id_ = item.id;
      // 将图片Feature添加到Source
      this.featureList.push(iconFeature)
    },
    // 添加设备图标集合
    initDevicePointList() {
      // 清除GIS地图中图标更新器
      if (this.updateDeviceIconTimer) {
        clearInterval(this.updateDeviceIconTimer);
        this.updateDeviceIconTimer = null;
      }
      // 添加图标集合
      this.updateDeviceIconTimer = setInterval(() => {
        // 清除map图标
        this.delDevicePoint()
        if (this.spaceMap.length !== 0 && this.deviceListWidthId != null && this.iconLayer.getSource().getFeatures().length === 0) {
          this.addDevicePointList();
          this.pollShowDeviceText();
          clearInterval(this.updateDeviceIconTimer);
          this.updateDeviceIconTimer = null;
        }
      }, 1000)
    },
    // 初始化设备图标集合图层
    addDevicePointList() {
      const vectorSource = new VectorSource()
      this.iconLayer = new VectorLayer({
        source: vectorSource
      })
      let deviceIconList = null;
      deviceIconList = this.spaceMap.filter(item => item.xoffset && item.yoffset && this.deviceListWidthId[item.deviceId] && this.deviceListWidthId[item.deviceId].typeEngName !== 'PM_WLD')
      deviceIconList.forEach(item => {
        this.addDevicePoint(item);
      })
      // 等待图标图层添加完再绑定鼠标悬浮和点击事件
      if (this.featureList != null && this.featureList.length !== 0) {
        // 将图标数组添加到图层中
        this.iconLayer.getSource().addFeatures(this.featureList)
        // 添加图层
        this.map && this.map.addLayer(this.iconLayer)
      }
    },
    // 根据id_删除图标
    delDevicePoint() {
      // 初始化设备点位集合图层
      this.featureList = [];
      this.iconLayer.getSource().getFeatures().forEach(item => {
        this.iconLayer.getSource().removeFeature(this.iconLayer.getSource().getFeatureById(item.id_));
      })
    },
    // 轮询显示图标设备名称
    pollShowDeviceText() {
      if (this.showDeviceTimer) {
        // 清空轮询设备tip定时器
        clearInterval(this.showDeviceTimer)
        this.showDeviceTimer = null;
      }
      let FeatrueList = this.iconLayer.getSource().getFeatures()
      let allSize = FeatrueList.length - 1;
      let currentSize = 0;
      /* start
       * 这里必须初始化一遍hoverFeature,不然在定时器延时等待过程中会出现拿不到hoverFeature的情况
       * */
      if (this.hoverFeature != null) {
        this.restoreDeviceText()
      }
      if (FeatrueList[currentSize]) {
        this.hoverFeature = FeatrueList[currentSize]
        this.hoverFeature.style_[1].text_.text_ = FeatrueList[currentSize].deviceName
        // 鼠标移入更改图标层级为优先级
        this.hoverFeature.changed()
      }
      currentSize++;
      /* end * */
      this.showDeviceTimer = setInterval(() => {
        if (this.hoverFeature != null) {
          this.restoreDeviceText()
        }
        if (currentSize > allSize) {
          currentSize = 0;
        }
        if (FeatrueList[currentSize]) {
          this.hoverFeature = FeatrueList[currentSize]
          this.hoverFeature.style_[1].text_.text_ = FeatrueList[currentSize].deviceName
          // 鼠标移入更改图标层级为优先级
          this.hoverFeature.changed()
        }
        currentSize++;
      }, 3000)
    },
    // 将设备tip标签值设置为空
    restoreDeviceText() {
      this.hoverFeature.style_[1].text_.text_ = ''
      this.hoverFeature.changed()
      this.hoverFeature = null;
    },
    // 判断设备图标信息值或坐标是否发生改变
    checkDeviceValueOrPosition() {
      let oldValue = this.deviceListWidthId
      let oldPosition = this.spaceMap.filter(item => item.xoffset && item.yoffset && this.deviceListWidthId[item.deviceId] && this.deviceListWidthId[item.deviceId].typeEngName !== 'PM_WLD')
      // 等待getDeviceListBySpaceIdAndCategoryTagId和getSpaceMap请求执行完
      setTimeout(() => {
        let newValue = this.deviceListWidthId
        let newPosition = this.spaceMap.filter(item => item.xoffset && item.yoffset && this.deviceListWidthId[item.deviceId] && this.deviceListWidthId[item.deviceId].typeEngName !== 'PM_WLD')
        if ((JSON.stringify(oldValue) !== JSON.stringify(newValue)) || JSON.stringify(oldPosition) !== JSON.stringify(newPosition)) {
          this.initDevicePointList();
        }
      }, 1300)
    },
    // 添加漏水线集合
    addSlacklineList() {
      // 清除所有漏水线图层
      this.slackLineLayers.forEach(item => {
        this.map.removeLayer(item)
      })
      this.slackLineLayers = []
      let slackLineDevice = this.spaceMap.filter(item => item.xoffset && item.yoffset && this.deviceListWidthId[item.deviceId] && this.deviceListWidthId[item.deviceId].typeEngName === 'PM_WLD')
      // 开始画线
      slackLineDevice.forEach(item => {
        let deviceInfo = this.deviceListWidthId[item.deviceId];
        let slackLineColor = deviceInfo.status === 0 ? 'green' : 'rgba(191, 40, 49, 0.85)'
        let positionList = []
        let yArray = item.yoffset.split(',');
        item.xoffset.split(',').forEach((item, index) => {
          if (index !== 0) {
            let convertX = parseFloat(item)
            let convertY = this.imgy - parseFloat(yArray[index])
            positionList.push([convertX, convertY])
          }
        })
        this.addSlackline(positionList, slackLineColor)
      })
    },
    // 添加漏水线
    addSlackline(positionList, color) {
      let featureLine = new Feature({
        geometry: new LineString(positionList)
      });
      featureLine.setStyle(new Style({
        stroke: new Stroke({
          color: color,
          width: 5
        })
      }))
      let source = new VectorSource()
      source.addFeature(featureLine)
      let layer = new VectorLayer()
      layer.setSource(source)
      // 储存所有漏水线图层源
      this.slackLineLayers.push(layer)
       this.map && this.map.addLayer(layer)
    }
  },
  mounted() {
    this.getSpaceInfo(this.spaceId)
    // 需要进行延迟来等待多个请求返回信息，才能初始化地图，否则拿不到空间信息，地图创建报null错误
    // 需要设置合理的时间，太快会导致创建多个地图，太慢会导致app端进入地图等待时间太长
    this.createMapTimer = setInterval(async () => {
      if (this.spaceMap.length !== 0 && this.deviceListWidthId && this.map === null) {
        // 初始化GIS地图
        await this.getBgImageInfo(this.initMap)
      }
    }, 15000)
    this.$store.dispatch('addIntervalObj', {
      'updateIndoorSetting:5000': () => {
        this.getDeviceList(this.spaceInfo.id)
      }
    })
    this.$store.dispatch('addIntervalObj', {
      'IndoorSettingTimerSelectDevice:5000': () => {
        this.timerSelectDevice()
      }
    })
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'updateIndoorSetting')
    this.$store.dispatch('removeIntervalObj', 'IndoorSettingTimerSelectDevice')
    // 清除GIS地图生成器
    clearInterval(this.createMapTimer)
    this.createMapTimer = null;
    // 清除GIS地图中图标更新器
    clearInterval(this.updateDeviceIconTimer);
    this.updateDeviceIconTimer = null;
    // 清除轮询设备tip定时器
    clearInterval(this.showDeviceTimer)
    this.showDeviceTimer = null;
  },
  watch: {
    spaceId(newVal) {
      this.spaceMap = []
      this.deviceList = []
      this.getSpaceInfo(newVal).then(() => {
        // 去掉地图背景图层
        if (this.map !== null) {
          if (this.map.getLayers() !== undefined && this.map.getLayers() != null && this.map.getLayers() !== '') {
            this.map.getLayers().forEach(item => {
              this.map.removeLayer(item)
            })
          }
          this.map.removeLayer(this.mapImageLayers)
          // 重新设置地图背景图层
          this.getBgImageInfo(this.changeDeviceMapImage)
        }
      })
    },
    categoryTagId() {
      this.deviceList = []
      this.spaceMap = []
      this.getDeviceList(this.spaceId)
      // 初始化图标图层
      if (this.map !== null) {
        this.initDevicePointList();
      }
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
}

.device-container {
  display: flex;
  align-items: center;
  justify-content: center;
}


::v-deep .ol-rotate {
  /* 设置地图旋转回正按钮位置，避免与全屏按钮重叠*/
  right: 3em;
}

</style>
